export const isFetching = state => state.userAccessLevels.fetching;
export const userAccessLevels = state => state.userAccessLevels.accessLevels;
export const hasFetchedAccessLevels = state =>
  Boolean(Object.keys(userAccessLevels(state)).length);
export const userEvents = state => state.userAccessLevels.userEvents;
export const userOrgs = state => state.userAccessLevels.userOrgs;
